module.exports = __webpack_public_path__ + "static/media/Blog.5f00d895.jpg";